// extracted by mini-css-extract-plugin
export default {"content":"SellerStatus_content__LoMoR","shopName":"SellerStatus_shopName__fIPsD","reason":"SellerStatus_reason__TK2MX"};